/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TransPb } from "../../gen/body/trans";
import { Uuid } from "../../gen/uuid_util/uuid";
import { PoseIdPb } from "./pose_id";

export const protobufPackage = "nav_cam_reconstruction";

export interface LoadRequest {
  utime: number;
  requestUuid: Uuid | undefined;
  loadPath: string;
  incrementalSavePath: string;
  estimateNcpgTNavTakeoff: TransPb | undefined;
}

export interface LoadResponse {
  utime: number;
  requestUuid: Uuid | undefined;
  success: boolean;
}

export interface FullMappingRequest {
  utime: number;
  requestUuid: Uuid | undefined;
  fileUuid: Uuid | undefined;
  enable: boolean;
}

export interface FullMappingResponse {
  utime: number;
  requestUuid: Uuid | undefined;
  success: boolean;
}

export interface AddSubjectCamVertexRequest {
  utime: number;
  requestUuid: Uuid | undefined;
}

export interface AddSubjectCamVertexResponse {
  utime: number;
  requestUuid: Uuid | undefined;
  success?: AddSubjectCamVertexResponse_Success | undefined;
  failure?: AddSubjectCamVertexResponse_Failure | undefined;
}

export interface AddSubjectCamVertexResponse_Success {
  addedPoseId: PoseIdPb | undefined;
}

export interface AddSubjectCamVertexResponse_Failure {
  reason: AddSubjectCamVertexResponse_Failure_Reason;
}

export enum AddSubjectCamVertexResponse_Failure_Reason {
  INVALID = 0,
  /**
   * NO_SUBJECT_CAM_INFO_AVAILABLE - No subject cam info (image, gimbal transform, etc.) has been recorded yet or the most
   * recent subject image has gone stale.
   */
  NO_SUBJECT_CAM_INFO_AVAILABLE = 1,
  /**
   * VERTEX_ALREADY_PRESENT - A vertex is already present in the pose graph with this flight index + utime. This could
   * correspond to a vertex with nav cams added automatically or a vertex with a subject cam
   * that was added with the same timestamp (e.g., if two requests are handled with the same
   * latest image).
   */
  VERTEX_ALREADY_PRESENT = 2,
  UNRECOGNIZED = -1,
}

export function addSubjectCamVertexResponse_Failure_ReasonFromJSON(
  object: any,
): AddSubjectCamVertexResponse_Failure_Reason {
  switch (object) {
    case 0:
    case "INVALID":
      return AddSubjectCamVertexResponse_Failure_Reason.INVALID;
    case 1:
    case "NO_SUBJECT_CAM_INFO_AVAILABLE":
      return AddSubjectCamVertexResponse_Failure_Reason.NO_SUBJECT_CAM_INFO_AVAILABLE;
    case 2:
    case "VERTEX_ALREADY_PRESENT":
      return AddSubjectCamVertexResponse_Failure_Reason.VERTEX_ALREADY_PRESENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AddSubjectCamVertexResponse_Failure_Reason.UNRECOGNIZED;
  }
}

export function addSubjectCamVertexResponse_Failure_ReasonToJSON(
  object: AddSubjectCamVertexResponse_Failure_Reason,
): string {
  switch (object) {
    case AddSubjectCamVertexResponse_Failure_Reason.INVALID:
      return "INVALID";
    case AddSubjectCamVertexResponse_Failure_Reason.NO_SUBJECT_CAM_INFO_AVAILABLE:
      return "NO_SUBJECT_CAM_INFO_AVAILABLE";
    case AddSubjectCamVertexResponse_Failure_Reason.VERTEX_ALREADY_PRESENT:
      return "VERTEX_ALREADY_PRESENT";
    case AddSubjectCamVertexResponse_Failure_Reason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseLoadRequest(): LoadRequest {
  return {
    utime: 0,
    requestUuid: undefined,
    loadPath: "",
    incrementalSavePath: "",
    estimateNcpgTNavTakeoff: undefined,
  };
}

export const LoadRequest = {
  encode(message: LoadRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUuid !== undefined) {
      Uuid.encode(message.requestUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.loadPath !== "") {
      writer.uint32(26).string(message.loadPath);
    }
    if (message.incrementalSavePath !== "") {
      writer.uint32(34).string(message.incrementalSavePath);
    }
    if (message.estimateNcpgTNavTakeoff !== undefined) {
      TransPb.encode(message.estimateNcpgTNavTakeoff, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoadRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.loadPath = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.incrementalSavePath = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.estimateNcpgTNavTakeoff = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUuid: isSet(object.requestUuid) ? Uuid.fromJSON(object.requestUuid) : undefined,
      loadPath: isSet(object.loadPath) ? globalThis.String(object.loadPath) : "",
      incrementalSavePath: isSet(object.incrementalSavePath) ? globalThis.String(object.incrementalSavePath) : "",
      estimateNcpgTNavTakeoff: isSet(object.estimateNcpgTNavTakeoff)
        ? TransPb.fromJSON(object.estimateNcpgTNavTakeoff)
        : undefined,
    };
  },

  toJSON(message: LoadRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUuid !== undefined) {
      obj.requestUuid = Uuid.toJSON(message.requestUuid);
    }
    if (message.loadPath !== "") {
      obj.loadPath = message.loadPath;
    }
    if (message.incrementalSavePath !== "") {
      obj.incrementalSavePath = message.incrementalSavePath;
    }
    if (message.estimateNcpgTNavTakeoff !== undefined) {
      obj.estimateNcpgTNavTakeoff = TransPb.toJSON(message.estimateNcpgTNavTakeoff);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadRequest>, I>>(base?: I): LoadRequest {
    return LoadRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadRequest>, I>>(object: I): LoadRequest {
    const message = createBaseLoadRequest();
    message.utime = object.utime ?? 0;
    message.requestUuid = (object.requestUuid !== undefined && object.requestUuid !== null)
      ? Uuid.fromPartial(object.requestUuid)
      : undefined;
    message.loadPath = object.loadPath ?? "";
    message.incrementalSavePath = object.incrementalSavePath ?? "";
    message.estimateNcpgTNavTakeoff =
      (object.estimateNcpgTNavTakeoff !== undefined && object.estimateNcpgTNavTakeoff !== null)
        ? TransPb.fromPartial(object.estimateNcpgTNavTakeoff)
        : undefined;
    return message;
  },
};

function createBaseLoadResponse(): LoadResponse {
  return { utime: 0, requestUuid: undefined, success: false };
}

export const LoadResponse = {
  encode(message: LoadResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUuid !== undefined) {
      Uuid.encode(message.requestUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.success === true) {
      writer.uint32(24).bool(message.success);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): LoadResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLoadResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LoadResponse {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUuid: isSet(object.requestUuid) ? Uuid.fromJSON(object.requestUuid) : undefined,
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
    };
  },

  toJSON(message: LoadResponse): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUuid !== undefined) {
      obj.requestUuid = Uuid.toJSON(message.requestUuid);
    }
    if (message.success === true) {
      obj.success = message.success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LoadResponse>, I>>(base?: I): LoadResponse {
    return LoadResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LoadResponse>, I>>(object: I): LoadResponse {
    const message = createBaseLoadResponse();
    message.utime = object.utime ?? 0;
    message.requestUuid = (object.requestUuid !== undefined && object.requestUuid !== null)
      ? Uuid.fromPartial(object.requestUuid)
      : undefined;
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseFullMappingRequest(): FullMappingRequest {
  return { utime: 0, requestUuid: undefined, fileUuid: undefined, enable: false };
}

export const FullMappingRequest = {
  encode(message: FullMappingRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUuid !== undefined) {
      Uuid.encode(message.requestUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.fileUuid !== undefined) {
      Uuid.encode(message.fileUuid, writer.uint32(26).fork()).ldelim();
    }
    if (message.enable === true) {
      writer.uint32(32).bool(message.enable);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FullMappingRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFullMappingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.fileUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.enable = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FullMappingRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUuid: isSet(object.requestUuid) ? Uuid.fromJSON(object.requestUuid) : undefined,
      fileUuid: isSet(object.fileUuid) ? Uuid.fromJSON(object.fileUuid) : undefined,
      enable: isSet(object.enable) ? globalThis.Boolean(object.enable) : false,
    };
  },

  toJSON(message: FullMappingRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUuid !== undefined) {
      obj.requestUuid = Uuid.toJSON(message.requestUuid);
    }
    if (message.fileUuid !== undefined) {
      obj.fileUuid = Uuid.toJSON(message.fileUuid);
    }
    if (message.enable === true) {
      obj.enable = message.enable;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FullMappingRequest>, I>>(base?: I): FullMappingRequest {
    return FullMappingRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FullMappingRequest>, I>>(object: I): FullMappingRequest {
    const message = createBaseFullMappingRequest();
    message.utime = object.utime ?? 0;
    message.requestUuid = (object.requestUuid !== undefined && object.requestUuid !== null)
      ? Uuid.fromPartial(object.requestUuid)
      : undefined;
    message.fileUuid = (object.fileUuid !== undefined && object.fileUuid !== null)
      ? Uuid.fromPartial(object.fileUuid)
      : undefined;
    message.enable = object.enable ?? false;
    return message;
  },
};

function createBaseFullMappingResponse(): FullMappingResponse {
  return { utime: 0, requestUuid: undefined, success: false };
}

export const FullMappingResponse = {
  encode(message: FullMappingResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUuid !== undefined) {
      Uuid.encode(message.requestUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.success === true) {
      writer.uint32(24).bool(message.success);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FullMappingResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFullMappingResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.success = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FullMappingResponse {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUuid: isSet(object.requestUuid) ? Uuid.fromJSON(object.requestUuid) : undefined,
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
    };
  },

  toJSON(message: FullMappingResponse): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUuid !== undefined) {
      obj.requestUuid = Uuid.toJSON(message.requestUuid);
    }
    if (message.success === true) {
      obj.success = message.success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FullMappingResponse>, I>>(base?: I): FullMappingResponse {
    return FullMappingResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FullMappingResponse>, I>>(object: I): FullMappingResponse {
    const message = createBaseFullMappingResponse();
    message.utime = object.utime ?? 0;
    message.requestUuid = (object.requestUuid !== undefined && object.requestUuid !== null)
      ? Uuid.fromPartial(object.requestUuid)
      : undefined;
    message.success = object.success ?? false;
    return message;
  },
};

function createBaseAddSubjectCamVertexRequest(): AddSubjectCamVertexRequest {
  return { utime: 0, requestUuid: undefined };
}

export const AddSubjectCamVertexRequest = {
  encode(message: AddSubjectCamVertexRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUuid !== undefined) {
      Uuid.encode(message.requestUuid, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddSubjectCamVertexRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSubjectCamVertexRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestUuid = Uuid.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSubjectCamVertexRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUuid: isSet(object.requestUuid) ? Uuid.fromJSON(object.requestUuid) : undefined,
    };
  },

  toJSON(message: AddSubjectCamVertexRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUuid !== undefined) {
      obj.requestUuid = Uuid.toJSON(message.requestUuid);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSubjectCamVertexRequest>, I>>(base?: I): AddSubjectCamVertexRequest {
    return AddSubjectCamVertexRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSubjectCamVertexRequest>, I>>(object: I): AddSubjectCamVertexRequest {
    const message = createBaseAddSubjectCamVertexRequest();
    message.utime = object.utime ?? 0;
    message.requestUuid = (object.requestUuid !== undefined && object.requestUuid !== null)
      ? Uuid.fromPartial(object.requestUuid)
      : undefined;
    return message;
  },
};

function createBaseAddSubjectCamVertexResponse(): AddSubjectCamVertexResponse {
  return { utime: 0, requestUuid: undefined, success: undefined, failure: undefined };
}

export const AddSubjectCamVertexResponse = {
  encode(message: AddSubjectCamVertexResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.requestUuid !== undefined) {
      Uuid.encode(message.requestUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.success !== undefined) {
      AddSubjectCamVertexResponse_Success.encode(message.success, writer.uint32(26).fork()).ldelim();
    }
    if (message.failure !== undefined) {
      AddSubjectCamVertexResponse_Failure.encode(message.failure, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddSubjectCamVertexResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSubjectCamVertexResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.requestUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.success = AddSubjectCamVertexResponse_Success.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.failure = AddSubjectCamVertexResponse_Failure.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSubjectCamVertexResponse {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      requestUuid: isSet(object.requestUuid) ? Uuid.fromJSON(object.requestUuid) : undefined,
      success: isSet(object.success) ? AddSubjectCamVertexResponse_Success.fromJSON(object.success) : undefined,
      failure: isSet(object.failure) ? AddSubjectCamVertexResponse_Failure.fromJSON(object.failure) : undefined,
    };
  },

  toJSON(message: AddSubjectCamVertexResponse): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.requestUuid !== undefined) {
      obj.requestUuid = Uuid.toJSON(message.requestUuid);
    }
    if (message.success !== undefined) {
      obj.success = AddSubjectCamVertexResponse_Success.toJSON(message.success);
    }
    if (message.failure !== undefined) {
      obj.failure = AddSubjectCamVertexResponse_Failure.toJSON(message.failure);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSubjectCamVertexResponse>, I>>(base?: I): AddSubjectCamVertexResponse {
    return AddSubjectCamVertexResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSubjectCamVertexResponse>, I>>(object: I): AddSubjectCamVertexResponse {
    const message = createBaseAddSubjectCamVertexResponse();
    message.utime = object.utime ?? 0;
    message.requestUuid = (object.requestUuid !== undefined && object.requestUuid !== null)
      ? Uuid.fromPartial(object.requestUuid)
      : undefined;
    message.success = (object.success !== undefined && object.success !== null)
      ? AddSubjectCamVertexResponse_Success.fromPartial(object.success)
      : undefined;
    message.failure = (object.failure !== undefined && object.failure !== null)
      ? AddSubjectCamVertexResponse_Failure.fromPartial(object.failure)
      : undefined;
    return message;
  },
};

function createBaseAddSubjectCamVertexResponse_Success(): AddSubjectCamVertexResponse_Success {
  return { addedPoseId: undefined };
}

export const AddSubjectCamVertexResponse_Success = {
  encode(message: AddSubjectCamVertexResponse_Success, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.addedPoseId !== undefined) {
      PoseIdPb.encode(message.addedPoseId, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddSubjectCamVertexResponse_Success {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSubjectCamVertexResponse_Success();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.addedPoseId = PoseIdPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSubjectCamVertexResponse_Success {
    return { addedPoseId: isSet(object.addedPoseId) ? PoseIdPb.fromJSON(object.addedPoseId) : undefined };
  },

  toJSON(message: AddSubjectCamVertexResponse_Success): unknown {
    const obj: any = {};
    if (message.addedPoseId !== undefined) {
      obj.addedPoseId = PoseIdPb.toJSON(message.addedPoseId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSubjectCamVertexResponse_Success>, I>>(
    base?: I,
  ): AddSubjectCamVertexResponse_Success {
    return AddSubjectCamVertexResponse_Success.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSubjectCamVertexResponse_Success>, I>>(
    object: I,
  ): AddSubjectCamVertexResponse_Success {
    const message = createBaseAddSubjectCamVertexResponse_Success();
    message.addedPoseId = (object.addedPoseId !== undefined && object.addedPoseId !== null)
      ? PoseIdPb.fromPartial(object.addedPoseId)
      : undefined;
    return message;
  },
};

function createBaseAddSubjectCamVertexResponse_Failure(): AddSubjectCamVertexResponse_Failure {
  return { reason: 0 };
}

export const AddSubjectCamVertexResponse_Failure = {
  encode(message: AddSubjectCamVertexResponse_Failure, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.reason !== 0) {
      writer.uint32(8).int32(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddSubjectCamVertexResponse_Failure {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSubjectCamVertexResponse_Failure();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSubjectCamVertexResponse_Failure {
    return { reason: isSet(object.reason) ? addSubjectCamVertexResponse_Failure_ReasonFromJSON(object.reason) : 0 };
  },

  toJSON(message: AddSubjectCamVertexResponse_Failure): unknown {
    const obj: any = {};
    if (message.reason !== 0) {
      obj.reason = addSubjectCamVertexResponse_Failure_ReasonToJSON(message.reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSubjectCamVertexResponse_Failure>, I>>(
    base?: I,
  ): AddSubjectCamVertexResponse_Failure {
    return AddSubjectCamVertexResponse_Failure.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSubjectCamVertexResponse_Failure>, I>>(
    object: I,
  ): AddSubjectCamVertexResponse_Failure {
    const message = createBaseAddSubjectCamVertexResponse_Failure();
    message.reason = object.reason ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
